import { jsx as _jsx } from "react/jsx-runtime";
// Career Miniapp — useSiteConfig hook + SiteConfigContext
import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api';
const SiteConfigContext = createContext(null);
export function SiteConfigProvider({ children }) {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const load = () => {
        setLoading(true);
        setError(null);
        api.siteConfig()
            .then(setConfig)
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    };
    useEffect(load, []);
    const value = {
        config,
        loading,
        error,
        refresh: load,
    };
    return _jsx(SiteConfigContext.Provider, { value: value, children: children });
}
export function useSiteConfigContext() {
    const ctx = useContext(SiteConfigContext);
    if (!ctx)
        throw new Error('useSiteConfigContext must be used inside SiteConfigProvider');
    return ctx;
}
export function useSiteConfig() {
    return useSiteConfigContext().config;
}
// [F-APPLYGUARD] nem dobó változat: provider nélkül (unit teszt, izolált render) null-t ad
export function useSiteConfigOptional() {
    const ctx = useContext(SiteConfigContext);
    return ctx ? ctx.config : null;
}
